import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// using 'as' replaces 'HashRouter' with the name 'Router'
import { Home } from "./pages/home";
import { Club } from "./pages/club";
import { Venue } from "./pages/venuesFees";
import { Team } from "./pages/team";
import { Calendar } from "./pages/calendar";
import { Gallery } from "./pages/gallery";
import { Links } from "./pages/links";
import { Contact } from "./pages/contact";
import { Judo } from "./pages/judo";
import { Privacy } from "./pages/privacy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/club" element={<Club />} />
        <Route path="/venue-fees" element={<Venue />} />
        <Route path="/what-is-judo" element={<Judo />} />
        <Route path="/team" element={<Team />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/links" element={<Links />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </Router>
  );
}

export default App;
